export default "__VITE_ASSET__Cm9GCO3D__"